function initSearch(section) {
  const input = section.querySelector('[data-project-search]');
  if (!input) return;

  const items = section.querySelectorAll('[data-project-search-parameters]');
  const empty = section.querySelector('[data-project-empty]');

  input.addEventListener('input', () => {
    const query = input.value.trim().toLowerCase();
    let visible = 0;

    items.forEach((item) => {
      const match = (item.dataset.projectSearchParameters || '').includes(query);

      item.hidden = !match;

      if (match) visible++;
    });

    if (empty) {
      empty.hidden = visible > 0;
    }

    refreshMasonry(section);
  });
}

const DESKTOP_BREAKPOINT = 750;

function isDesktop() {
  return window.innerWidth >= DESKTOP_BREAKPOINT;
}

function resizeItem(item) {
  const grid = item.closest('.project-listing__grid');
  if (!grid) return;

  const image = item.querySelector('img');
  if (!image || !image.complete) return;

  const styles = getComputedStyle(grid);
  const rowHeight = parseFloat(styles.gridAutoRows);
  const rowGap = parseFloat(styles.rowGap);

  const imageHeight = image.getBoundingClientRect().height;

  item.style.height = `${imageHeight}px`;

  const rowSpan = Math.ceil((imageHeight + rowGap) / (rowHeight + rowGap));
  item.style.gridRowEnd = `span ${rowSpan}`;
}

function resetMasonry(section) {
  section.querySelectorAll('.project-listing__item').forEach((item) => {
    item.style.removeProperty('height');
    item.style.removeProperty('grid-row-end');
  });
}

function layoutGrid(grid) {
  grid
    .querySelectorAll('.project-listing__item:not([hidden])')
    .forEach(resizeItem);
}

function refreshMasonry(section) {
  if (!isDesktop()) {
    resetMasonry(section);
    return;
  }

  section
    .querySelectorAll('.project-listing__grid')
    .forEach(layoutGrid);
}

function initMasonry(section) {
  refreshMasonry(section);

  window.addEventListener('resize', () => {
    refreshMasonry(section);
  });

  document.fonts?.ready.then(() => {
    refreshMasonry(section);
  });

  section.querySelectorAll('.project-listing__grid img').forEach((img) => {
    if (img.complete) {
      resizeItem(img.closest('.project-listing__item'));
    } else {
      img.addEventListener(
        'load',
        () => {
          if (isDesktop()) {
            resizeItem(img.closest('.project-listing__item'));
          }
        },
        { once: true }
      );
    }
  });

  if ('ResizeObserver' in window) {
    const observer = new ResizeObserver((entries) => {
      if (!isDesktop()) return;

      entries.forEach(({ target }) => {
        const item = target.closest('.project-listing__item');
        if (item) resizeItem(item);
      });
    });

    section
      .querySelectorAll('.project-listing__grid img')
      .forEach((img) => observer.observe(img));
  }
}

document.querySelectorAll('.project-listing').forEach((section) => {
  initSearch(section);
  initMasonry(section);
});

document.addEventListener('shopify:section:load', (event) => {
  event.target.querySelectorAll('.project-listing').forEach((section) => {
    initSearch(section);
    initMasonry(section);
  });
});